<template>
  <div
    ref="svg"
    style="position: relative; display: grid; grid-template-columns: 1fr 1fr;"
    v-bind:class="['root', 'geo-chart-'+ numerator + '-' + denominator, {'col_1_2': $mq === 'sm' || printing}, {'tileCLick': tileCLick}]"
    v-on:click.prevent="setIndicator([numerator, denominator])"
    v-bind:href="$router.resolve({ query: {...$route.query, shortcut: url} } ).href"
    class="clickCursor">
    <span style="font-size: large; font-weight: bold; color: #0f2d53; grid-column: 1 / 3;">
      <font-awesome-icon v-if="tileCLick"
                         icon="map-marked"
                         title="Currently mapped"/>
    {{ name }}               <span class="info"
                v-if="equityTooltips[numerator] && !nonScoreIndicators.includes(numerator)"
                v-tooltip="{
                        content: equityTooltips[numerator].content,
                        classes: ['d3-tip'],
                        container: $refs.svg,
                      }"
          ></span></span>

    <div v-if="selectedId" style="font-size: x-large; grid-column: 1;" class="contextGeog">
      <span v-if="selected">{{ typeof selected.value[1] !== 'string' ? format(selected.value[1]) : selected.value[1] }}</span>
      <span v-else>{{ '0%' }}</span>
    </div>
    <gaugeChart v-if="selectedId && numerator !== 'hhmedinc_24' && !nonScoreIndicators.includes(numerator)" v-bind:chartData="gaugeData[0]"
                v-bind:options="gaugeData[1]"
                v-bind:style="{width: '75%', height: '7vh', position: 'relative', gridColumn: 2}"/>
    <div v-if="regionData && numerator !== 'disadvantagedcommunity' && numerator !== 'raise' && numerator !== 'dac_cvr'" style="grid-column: 1"
         class="contextGeog">
      &nbsp;<span>Southeast Michigan: {{ format((regionData[numerator] / regionData[denominator]) || 0) }}</span>
    </div>
    <div v-if="countyData && countyData.name && numerator !== 'disadvantagedcommunity' && numerator !== 'raise' && numerator !== 'dac_cvr'"
         style="grid-column: 1" class="contextGeog">&nbsp;<span>{{
        countyData.name
      }}: {{ format((countyData[numerator] / countyData[denominator]) || 0) }}</span>
    </div>
    <div v-if="selected && selected.numerator >= 0 && !nonScoreIndicators.includes(numerator)"
         style="grid-column: 2; grid-row: 3" class="contextGeog">&nbsp;<span>{{
        getIndName(numerator)
      }}: {{ formatNumber(selected.numerator) }}</span>
    </div>
    <div v-if="selected && selected.score >= 0 && !nonScoreIndicators.includes(numerator)"
         style="grid-column: 2; grid-row: 4" class="contextGeog">&nbsp;<span>Score: {{ selected.score }}</span>
    </div>
    <div class="mapboxgl-ctrl-top-right" style="z-index: auto">
      <div class="mapboxgl-ctrl mapboxgl-ctrl-group" v-bind:title="'Download CSV for: ' + name"
           v-on:click.stop="saveFile()">
        <font-awesome-icon class="save-file" icon="file-download"/>
      </div>
      <AboutPage style="pointer-events: auto; z-index: auto" class="about" v-if="aboutPageContent[numerator]"
                 v-bind:content="aboutPageContent[numerator]"
                 v-bind:name="name">
      </AboutPage>

    </div>
  </div>
</template>


<script>

import debounce from 'lodash.debounce'
import * as d3 from 'd3'
import scrollMonitor from 'scrollmonitor'
import gaugeChart from './gaugeChart.vue'
import AboutPage from '../AboutPage.vue'
import {saveAs} from 'file-saver';

export default {
  name: 'GioDistributionChart',
  components: { gaugeChart, AboutPage },
  props: [
    'name',
    'url',
    'numerator',
    'denominator',
    'selectedTiles',
    'nonScoreIndicators',
    'scoreColorLookup',
    'aboutPageContent',
    'equityTooltips',
    'D3FormatterString',
    'selectedId',
    'hoverId',
    'geogData',
    'getIndName',
    'isSelectedShortcfut',
    'colorLegendData',
    'countyData',
    'regionData',
    'hideWhenInvisible',
    'printing',
  ],
  data: function () {
    return {
      margin: { top: 15, right: 10, bottom: 10, left: 10 },
      width: 500,
      height: 140,
      yAxisWidth: 49,
      visible: !this.hideWhenInvisible,
      tileCLick: false,
    }
  },
  mounted: function () {
    if (this.hideWhenInvisible) {
      let profile = document.getElementById('charts')
      let containerMonitor = scrollMonitor.createContainer(profile)
      let elementWatcherProfile = containerMonitor.create(this.$refs.svg)
      let elementWatcher = scrollMonitor.create(this.$refs.svg)
      let callBack = debounce(() => {
        if (this.$mq === 'sm') {
          this.visible = elementWatcher.isInViewport
        } else {
          this.visible = elementWatcherProfile.isInViewport
        }
      }, 400)
      elementWatcher.visibilityChange(callBack)
      elementWatcherProfile.visibilityChange(callBack)
      callBack()
      this.$once('hook:beforeDestroy', function () {
        elementWatcher.destroy()
        elementWatcherProfile.destroy()
        containerMonitor.destroy()
      })
    }
  },
  methods: {
    setIndicator: function (id) {
      this.$emit('set-map', id)
    },
    setSelected: function (id) {
      this.$emit('set-sel-geom-id', id)
    },
    saveFile: function () {
      // eslint-disable-next-line no-undef
      ga('send', 'event', 'DownloadCSV', this.name, 'Demographic Emphasis Areas')
      // eslint-disable-next-line no-undef
      gtag('event', "DownloadCSV", {'change': this.name, 'map_name': 'Demographic Emphasis Areas'})
      let blob = ''
      if (this.nonScoreIndicators.includes(this.numerator)) {
        blob = new Blob([
          'Id,Name,', this.name + '\n',
          this.geogdata_sorted.map(d => [d.geoid, d.name, d.value[1]].join(',')).join('\n'),
        ], {type: 'text/plain;charset=utf-8'})
      } else {
        blob = new Blob([
          'Id,Name,', this.name, ',' + this.name + ' Score', ',' + this.name + ' Numerator Value\n',
          this.geogdata_sorted.map(d => [d.geoid, d.name, d.value[1], d.score, d.numerator].join(',')).join('\n'),
        ], {type: 'text/plain;charset=utf-8'})
      }
      saveAs(blob, 'SEMCOG DemographicData ' + this.name + ' 2020-2024 ACS_Data.csv')
    },
  },
  computed: {
    hasMoe: function () {
      return this.geogData.some(d => d.value[0] !== d.value[2])
    },
    format: function () {
      return d3.format(this.D3FormatterString || '.0%')
    },
    formatNumber: function () {
      return d3.format(this.D3FormatterString || ',.0f')
    },
    geogdata_sorted: function () {
      function compare(a, b) {
        const A = a.geoid;
        const B = b.geoid;
        let comparison = 0;
        if (A > B) {
          comparison = 1;
        } else if (A < B) {
          comparison = -1;
        }
        return comparison;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.geogData.sort(compare)
    },
    gaugeData: function () {

      let color = ['grey', '#dbdbdb']
      let data = [0, 1]
      if (this.selected) {
        color = [this.scoreColorLookup[this.selected.score].color || '#2b83ba', '#dbdbdb']
        data = [this.selected.value[0], 1-this.selected.value[0]]
      }
      return [{
        labels: [],
        datasets: [
          {
            backgroundColor: color,
            data: data,
          },
          // {
          //   backgroundColor: ['rgb(62,62,62)', 'white'],
          //   borderColor: 'black',
          //   borderWidth: 1,
          //   data: [this.countyData[this.numerator] / this.countyData[this.denominator], 1-(this.countyData[this.numerator] / this.countyData[this.denominator]) || 0],
          // },
          // {
          //   backgroundColor: ['rgb(49,49,49)', 'white'],
          //   borderColor: 'black',
          //   borderWidth: 1,
          //   data: [this.regionData[this.numerator] / this.regionData[this.denominator] || 0, 1-(this.regionData[this.numerator] / this.regionData[this.denominator]) || 0],
          // },
        ],
      }, {
        title: {
          text: this.name,
          fontSize: 18,
          fontColor: 'black',
          position: 'top',
          display: false,
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
        },
        plugins: {
          datalabels: {
            color: 'black',
            textShadowBlur: 6,
            textShadowColor: 'white',
            display: function (context) {
              return context.dataIndex === 0;
            },
            font: {
              weight: 'bold',
            },
            formatter: this.format,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        circumference: Math.PI,
        rotation: -Math.PI,
      }]
    },
    selected: function () {
      return this.geogData.find(datum => datum.geoid === (this.hoverId || this.selectedId))
    },
  },
  watch: {
    selectedTiles: {
      immediate: true,
      handler:
        function () {
          this.tileCLick = !!this.selectedTiles.includes(this.numerator);
        },
    },

  }}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only. /deep/ applies to children as well -->
<style scoped>
  svg {
    width: 100%;
  }

  .root {
    position: relative;
    background: white;
    padding: 7px;
    margin: 9px;
    border-radius: 5px;
    border-color: #cbc7c7;
    border-width: 1px;
    border-style: solid;
    box-shadow: 10px 20px 17px -8px #cbc7c7;
  }

  .info {
    content: '';
    cursor: pointer;
    position: absolute;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill='%23333333' fill-rule='evenodd' d='M4,10a6,6 0 1,0 12,0a6,6 0 1,0 -12,0 M9,7a1,1 0 1,0 2,0a1,1 0 1,0 -2,0 M9,10a1,1 0 1,1 2,0l0,3a1,1 0 1,1 -2,0'/%3E %3C/svg%3E");
    background-color: rgba(255, 255, 255, 0.5);
    width: 20px;
    height: 20px;
    box-sizing: border-box;
    border-radius: 10px;
  }


  /deep/ .my-tooltip {
    display: block !important;
    z-index: 1;
    font-size: small;
    max-width: 90%;
  }

  .my-tooltip strong {
    font-size: medium;
  }

   .my-tooltip small {
    color: #9aa5a9;
    font-size: small;
  }

  .my-tooltip .my-tooltip-inner {
    background: #292424;
    color: white;
    opacity: 0.95;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }

.my-tooltip .my-tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: #292424;
    opacity: 0.95;
    z-index: 1;
  }

  /deep/.my-tooltip[x-placement^="top"] {
    margin-bottom: 10px;
  }
 .my-tooltip[x-placement^="top"] .my-tooltip-arrow {
    border-width: 5px 5px 0 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    bottom: -5px;
    left: calc(50% - 10px);
    margin-top: 0;
    margin-bottom: 0;
  }
  /deep/ .my-tooltip[x-placement^="bottom"] {
    margin-top: 10px;
  }
  .my-tooltip[x-placement^="bottom"] .my-tooltip-arrow {
    border-width: 0 5px 5px 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-top-color: transparent !important;
    top: -5px;
    left: calc(50% - 10px);
    margin-top: 0;
    margin-bottom: 0;
  }
  /deep/ .my-tooltip[x-placement^="right"] {
    margin-left: 10px;
  }
  .my-tooltip[x-placement^="right"] .my-tooltip-arrow {
    border-width: 5px 5px 5px 0;
    border-left-color: transparent !important;
    border-top-color: transparent !important;
    border-bottom-color: transparent !important;
    left: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
  }
  /deep/ .my-tooltip[x-placement^="left"] {
    margin-right: 10px;
  }
  .my-tooltip[x-placement^="left"] .my-tooltip-arrow {
    border-width: 5px 0 5px 5px;
    border-top-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    right: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
  }
 .my-tooltip.popover .popover-inner {
    background: #f9f9f9;
    color: #292424;
    padding: 24px;
    border-radius: 5px;
    box-shadow: 0 5px 30px rgba(0, 0, 0, .1);
  }
  .my-tooltip.popover .popover-arrow {
    border-color: #f9f9f9;
  }
  /deep/ .my-tooltip[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
  }
  /deep/ .my-tooltip[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
  }

  .mapboxgl-ctrl-top-right{
    z-index: 1;
  }

  .save-file {
    width: 20px;
    height: 20px;
    padding: 1px;
  }

  /deep/ .hover-bar {
    fill: #22323b;
    color: #22323b;
    opacity: 1;
  }

  /deep/ .selected-bar {
    fill: #dc4915;
    color: #dc4915;
    opacity: 1;
  }

  h2, h3, h4, h5 {
    margin: 0;
  }

  .clickCursor {
    font-size: 1.17em;
    color: #0f2d53;
    font-weight: bold;
    vertical-align: middle;
    /*text-decoration: none;*/
  }
    .about {
      font-size: 1em;
      font-weight: normal;
      vertical-align: unset;
      color: black;
      /*text-decoration: none;*/
    }

  .clickCursor:hover {
    cursor: pointer;
    box-shadow: 10px 20px 17px -8px #616060;
  }
  .tileCLick {
    border: 3px black solid;
    background: rgba(148, 166, 186, 0.2);
  }

  .contextGeog {
    font-size: 0.7rem;
    margin: 1px;
    padding: 1px;
    line-height: 1.25em;
  }

  svg:focus, h6:focus {
    outline: 0;
    border-radius: 4px;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
  }

  .moeLegend {
    display: none;
  }

  .col_1_2 .moeLegend {
    display: inherit;
  }

  @media (max-width: 576px), print {
    .mapboxgl-ctrl-icon {
      display: none;
    }

    .root {
      page-break-before: auto;
      page-break-inside: avoid;
    }
  }
</style>
